/**
 * @file Handle purchase-album-photos redirect requests.
 */

import React, { Component } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import qs from 'query-string';

import { MeWithIdentitiesAndAlbumMembershipsTotals } from '../../graphql/queries/account';
import { getAlbumMembershipById } from '../../util/account';
import { sentryCaptureMessage } from '../../util/sentry';
import { getAlbumMembershipBranchLinkRedirectId } from '../../util/purchase-album';

class PurchaseAlbumPhotosRedirect extends Component {
  static propTypes = {
    albumMembership: PropTypes.shape({
      album: PropTypes.shape({
        id: PropTypes.string,
      }),
      matched_photos: PropTypes.shape({
        total: PropTypes.number,
      }),
      entitled_matched_photos: PropTypes.shape({
        total: PropTypes.number,
      }),
    }),
    loading: PropTypes.bool,
    location: PropTypes.shape({
      search: PropTypes.string,
    }),
  };

  render() {
    const { albumMembership, loading, location } = this.props;

    if (loading) {
      return null;
    }

    if (!albumMembership) {
      sentryCaptureMessage(
        'Purchase Album Photos Redirect :: Invalid album membership',
        {
          level: 'error',
          extra: { location },
        },
      );

      const redirectToError = {
        pathname: '/error',
        state: {
          error: 'Link is no longer valid',
        },
      };

      return <Redirect to={redirectToError} />;
    }

    const redirectId = getAlbumMembershipBranchLinkRedirectId(albumMembership);

    return <Redirect to={`/consumer/matches/${redirectId}`} />;
  }
}

const withUserAlbumMemberships = graphql(
  MeWithIdentitiesAndAlbumMembershipsTotals,
  {
    options: () => ({
      ssr: false,
    }),
    props: ({ data: { me, loading }, ownProps: { location } }) => ({
      identities: me && me.linked_identities && me.linked_identities.records,
      albumMembership: getAlbumMembershipById(
        me,
        qs.parse(location.search).albumMembership || '',
      ),
      accountId: me && me.id,
      loading,
    }),
  },
);

export { PurchaseAlbumPhotosRedirect };

export default compose(
  withRouter,
  withUserAlbumMemberships,
)(PurchaseAlbumPhotosRedirect);
